<template>
  <el-select
    ref="infinite-dropdown"
    class="w-100"
    v-model="filter"
    :placeholder="placeholder"
    :name="`search-${fieldName}`"
    :no-match-text="noMatchText"
    clearable
    multiple
  >
    <span slot="prefix" class="color-primary h-100 d-flex align-items-center" v-html="prefix" />
    <el-option v-for="{ key, value, html } in options" :key="`search-${fieldName}-${key}`" :label="value" :value="key">
      <span slot="prefix" class="color-primary h-100 d-flex align-items-center" v-html="prefix" />
      <span class="d-flex align-items-center" v-html="html" />
    </el-option>
  </el-select>
</template>

<script>
import { get } from 'lodash'
import { DROPDOWN_BOOLEAN_OPTIONS } from '../lib/list-constants'

const EXCLUDED_KEYS = ['null']

export default {
  name: 'FilterBoolean',
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      query: '',
      options: DROPDOWN_BOOLEAN_OPTIONS(this.$i18n.t).filter((option) => !EXCLUDED_KEYS.includes(option.key)),
    }
  },
  computed: {
    fieldName() {
      const data = get(this.field, 'data')
      const label = get(this.field, 'label')
      return data || label
    },
    filter: {
      get() {
        return this.$get('columnFilter')(this.fieldName, '')
      },
      set(filter) {
        this.$dispatch('setFilter', { data: this.fieldName, filter })
        this.$emit('apply-filter')
      },
    },
    noMatchText() {
      return this.$i18n.t('no_result')
    },
    placeholder() {
      return this.$i18n.t('select_item')
    },
    prefix() {
      switch (this.filter) {
        case 0:
        case '0':
          return `<span class="material-icons md-18">check_box_outline_blank</span>`
        case 1:
        case '1':
          return `<span class="material-icons md-18">check_box</span>`
        default:
          return `<span class="material-icons md-18"></span>`
      }
    },
  },
}
</script>
